import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Radio } from 'antd'

import B2becAddressForm from '@/components/B2becAddressForm'
import SearchAddress from 'pages/CheckoutPage/StepOneComponent/SearchAddress'
import { useAppSelector } from '@/store/hook'
import { selectUserCountry } from '@/store/selectors/userSelector'
import { selectDeliveryAddresses } from '@/store/slices/customerSlice'
import { useCountryName } from '@/hooks'

const defaultValue = {
  partnerNumber: '',
  isAddNew: false,
}

const SelectAddress = ({ value = defaultValue, onChange }) => {
  const { t } = useTranslation()
  const [radioValue, setRadioValue] = useState(1)
  const deliveryAddresses = useAppSelector(selectDeliveryAddresses)
  const country = useAppSelector(selectUserCountry)
  const countryName = useCountryName(country)
  const [selectedPartnerNumber, setSelectedPartnerNumber] = useState(
    value?.partnerNumber,
  )

  const handleSwitchRadio = useCallback(
    (e) => {
      const selected = e.target.value
      if (selected === 1) {
        const selectedAddress = deliveryAddresses.find(
          (item) => item.partnerNumber === selectedPartnerNumber,
        )
        onChange({ ...selectedAddress, isAddNew: false })
      } else {
        onChange({ country: countryName, isAddNew: true })
      }
      setRadioValue(selected)
    },
    [countryName, deliveryAddresses, onChange, selectedPartnerNumber],
  )

  const handleSelectAddress = useCallback(
    (selectedAddress) => {
      onChange({ ...selectedAddress, isAddNew: false })
      setSelectedPartnerNumber(selectedAddress.partnerNumber)
    },
    [onChange],
  )

  return (
    <div>
      <Radio.Group
        className="custom-input select-address__group__label"
        defaultValue={1}
        style={{ width: '100%' }}
        onChange={handleSwitchRadio}
      >
        <Radio key={1} value={1}>
          <span className="mt-6 mb-4 delivery__option__title">
            {t('form.label.myAddress')}
          </span>
        </Radio>
        <Radio key={2} value={2}>
          <span className="mt-6 mb-4 delivery__option__title">
            {t('form.label.newAddress')}
          </span>
        </Radio>
      </Radio.Group>
      {radioValue === 2 ? <B2becAddressForm id="deliveryAddress" /> : (
        <SearchAddress
          dataSource={deliveryAddresses}
          value={value}
          onChange={handleSelectAddress}
        />
      )}
    </div>
  )
}

export default SelectAddress
